export const strings = {
  title: 'エマージェンシー履歴',
  availableOpenLockerBox: 'ロッカー解錠可',
  unavailableOpenLockerBox: 'ロッカー解錠不可',
  queryDateTitle: '期間で絞り込む',
  queryStationTitle: 'ステーションで絞り込む',
  queryButton: '検索',
  queryPlaceHolder: 'すべて',
  noStations: 'ステーション情報がありません',
  loadingStations: '読み込み中…',
  emptyTableMessage: '該当するエマージェンシーはありません。',
  initialEmptyMessage: '期間を指定して検索してください',
}

export const emergenciesTableContent = [
  '',
  'ID',
  '発生起因',
  'メッセージ',
  'ロッカー解錠可否',
  '発生日時',
  '解決日時',
  'NUCバージョン',
  'ステーションID',
  'マシンID',
]
